import { Action, createReducer, on } from '@ngrx/store';

import * as FavoriteOccupationsActions from './favorite-occupations.actions';
import * as FavoriteOccupationsFeatureState from './favorite-occupations.state';

const favoriteMilitaryOccupationsReducer = createReducer(
  FavoriteOccupationsFeatureState.initialFavoriteMilitaryOccupationsState,

  on(
    FavoriteOccupationsActions.favoriteMilitaryOccupationsLoadedSuccess,
    (state, { favoriteMilitaryOccupations }) => ({
      ...state,
      favoriteMilitaryOccupations
    })
  ),

  on(
    FavoriteOccupationsActions.favoriteMilitaryOccupationAddedSuccess,
    (state, { favoriteMilitaryOccupation }) => ({
      ...state,
      similarMilitaryOccupations: state.similarMilitaryOccupations?.map((e) =>
        e.mocCode === favoriteMilitaryOccupation.mocCode &&
        e.mocTitle === favoriteMilitaryOccupation.mocTitle
          ? { ...e, isFavorite: true }
          : e
      ),
      militaryOccupationsForGoal: state.militaryOccupationsForGoal?.map((e) =>
        e.mocCode === favoriteMilitaryOccupation.mocCode &&
        e.mocTitle === favoriteMilitaryOccupation.mocTitle
          ? { ...e, isFavorite: true }
          : e
      ),
      favoriteMilitaryOccupations: [
        ...state.favoriteMilitaryOccupations,
        favoriteMilitaryOccupation
      ],
      userReclassifying: null
    })
  ),

  on(
    FavoriteOccupationsActions.favoriteMilitaryOccupationRemovedSuccess,
    (state, { mocCode, mocTitle }) => ({
      ...state,
      similarMilitaryOccupations: state.similarMilitaryOccupations?.map((e) =>
        e.mocCode === mocCode && e.mocTitle === mocTitle
          ? { ...e, isFavorite: false }
          : e
      ),
      militaryOccupationsForGoal: state.militaryOccupationsForGoal?.map((e) =>
        e.mocCode === mocCode && e.mocTitle === mocTitle
          ? { ...e, isFavorite: false }
          : e
      ),
      favoriteMilitaryOccupations: state.favoriteMilitaryOccupations?.filter(
        (e) => e.mocCode !== mocCode && e.mocTitle !== mocTitle
      )
    })
  ),

  on(FavoriteOccupationsActions.loadSimilarMilitaryOccupations, (state) => ({
    ...state
  })),

  on(
    FavoriteOccupationsActions.loadSimilarMilitaryOccupationsSuccess,
    (state, { occupations }) => ({
      ...state,
      similarMilitaryOccupations: occupations
    })
  ),

  on(
    FavoriteOccupationsActions.loadSimilarMilitaryOccupationsFailed,
    (state) => ({
      ...state
    })
  ),
  // WALK-71 review. Null while loading, so the goal dialog shows "Loading"
  // rather than the previous goal's occupations or "none".
  on(FavoriteOccupationsActions.loadMilitaryOccupationsForGoal, (state) => ({
    ...state,
    militaryOccupationsForGoal: null
  })),

  on(
    FavoriteOccupationsActions.loadMilitaryOccupationsForGoalSuccess,
    (state, { occupations }) => ({
      ...state,
      militaryOccupationsForGoal: occupations
    })
  ),

  on(
    FavoriteOccupationsActions.loadMilitaryOccupationsForGoalFailed,
    (state) => ({
      ...state,
      militaryOccupationsForGoal: []
    })
  ),
  on(FavoriteOccupationsActions.updateReclassifyingSuccess, (state,{ userReclassifying }) => ({
    ...state,
    userReclassifyingLoaded: true,
    userReclassifying,
    similarMilitaryOccupations: state.similarMilitaryOccupations?.map((e) => ({ ...e, isFavorite: false })),
    militaryOccupationsForGoal: state.militaryOccupationsForGoal?.map((e) => ({ ...e, isFavorite: false })),
    favoriteMilitaryOccupations: []
  })),
  on(FavoriteOccupationsActions.loadUserReclassifying, (state) => ({
    ...state
  })),

  on(
    FavoriteOccupationsActions.userReclassifyingSuccess,
    (state, { userReclassifying }) => ({
      ...state,
      userReclassifying,
      userReclassifyingLoaded: true
    })
  )
);

export function reducer(
  state:
    | FavoriteOccupationsFeatureState.FavoriteMilitaryOccupationsState
    | undefined,
  action: Action
) {
  return favoriteMilitaryOccupationsReducer(state, action);
}
